import type { AxiosResponse } from 'axios';

import { APIError } from '@/references/axios/APIError';

import { parseContentType } from './parseContentType';

export const assertContentType = (headers: AxiosResponse['headers'], required: string): void => {
  const contentType = parseContentType(headers);
  if (required === contentType) {
    return;
  }

  throw new APIError(
    `Received response with invalid Content-Type of ${contentType}, requested ${required}`,
    'INVALID_RESPONSE_TYPE'
  );
};
